
import PackageJson from '../../package.json';

export default {
  data() {
    return {

    }
  },
  methods: {
    jump(item, param){
      this.$router.push({ path: item, query: param });
    },
    changeRouter(item, param) {
      // this.$store.commit("SET_KEEP_ALIVE", []);
      this.$router.push({ name: item, params: param });
    },
    /* @routerName路由名称
       @name跳转后页面名称
       @param参数列表
    */
    junmpToDetail(routerName, name, param) {//跳转页面的同时添加面包屑导航
      console.log(param)
      this.$store.commit("SET_KEEP_ALIVE", []);
      this.$router.push({ name: routerName, params: param });
      // this.bus.$emit('pushCrumb', {name:name,url:routerName});
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins/link.js